var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80254 11.4708C6.57054 11.4708 7.00254 11.0388 7.00254 10.2708C7.00254 9.5028 6.57054 9.0708 5.80254 9.0708C5.03454 9.0708 4.60254 9.5028 4.60254 10.2708C4.60254 11.0388 5.03454 11.4708 5.80254 11.4708Z",
    fill: "#84C70D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2029 11.4708C10.9709 11.4708 11.4029 11.0388 11.4029 10.2708C11.4029 9.5028 10.9709 9.0708 10.2029 9.0708C9.43493 9.0708 9.00293 9.5028 9.00293 10.2708C9.00293 11.0388 9.43493 11.4708 10.2029 11.4708Z",
    fill: "#84C70D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6023 11.4708C15.3703 11.4708 15.8023 11.0388 15.8023 10.2708C15.8023 9.5028 15.3703 9.0708 14.6023 9.0708C13.8343 9.0708 13.4023 9.5028 13.4023 10.2708C13.4023 11.0388 13.8343 11.4708 14.6023 11.4708Z",
    fill: "#84C70D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.8e422029b14d402df86c0cd3aa2fb44c.svg";
export { ForwardRef as ReactComponent };